module.exports = __webpack_public_path__ + "img/d201205-1.f6121c30.jpg";